export default "__VITE_ASSET__BcgUBnC2__"